import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {setPromptVariable} from "@khan/guide-core-helpers";

// eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
import type {AITeacherTools_VideoDetailsType} from "./__graphql-types__/index.ts";
import {unsetSharedDetails} from "./shared-details.ts";

export const VIDEO_DETAILS_QUERY: GqlOperation<
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_VideoDetailsType["response"],
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_VideoDetailsType["variables"]
> = gqlOp(gql`
    query AITeacherTools_VideoDetails($videoId: String) {
        videoById(contentId: $videoId) {
            id
            translatedTitle
            defaultUrlPath
            parentTopic {
                id
                domainSlug
                allLearnableContent(includeUnlisted: false) {
                    id
                    translatedTitle
                    defaultUrlPath
                }
            }
            subtitles {
                text
            }
        }
    }
`);

export function unloadVideoDetails() {
    ["contentTitle", "context", "domain", "videoTranscript"].forEach(
        (variable) => {
            setPromptVariable(variable, null);
        },
    );
    unsetSharedDetails();
}
